module.exports = __webpack_public_path__ + "static/0030-d001a9b9026fc266e814b82877598ccf.png";